// extracted by mini-css-extract-plugin
export var fullwidthWrapper = "wavy-white-layout-module--fullwidth-wrapper--uDPWj";
export var topSeparator = "wavy-white-layout-module--top-separator--fuxbg";
export var bottomSeparator = "wavy-white-layout-module--bottom-separator--ulujN";